import Nav from "../../components/UI/Nav";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import Transition from "../../components/UI/Transition";
import ProjectFooter from "../../components/UI/Footer/ProjectFooter";
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

const redesignComparisons = [
    {
        title: "Home Main",
        oldImage: "old-1.png",
        newImage: "new-1.png",
    },
    {
        title: "Home",
        oldImage: "old-2.png",
        newImage: "new-2.png",
    },
    {
        title: "Service",
        oldImage: "old-service.png",
        newImage: "new-service.png",
    },
    {
        title: "Product",
        oldImage: "old-product-1.png",
        newImage: "new-product-1.png",
    },
];

export default function Senmy() {
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(0);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    const comparisonSlides = redesignComparisons.flatMap((comparison) => [
        { src: `/assets/projects/senmy/${comparison.oldImage}`, title: `${comparison.title} old design` },
        { src: `/assets/projects/senmy/${comparison.newImage}`, title: `${comparison.title} new design` },
    ]);

    return (
        <Transition>
            <div
                style={{ backgroundColor: "#d7d5e0" }}
                className="main__container re-padding"
            >
                <div className="menu__fix">
                    <Nav />
                </div>

                <div className="pictok__container">
                    <section
                        className="infj__topContainer topContainer"
                        style={{ backgroundColor: "#c0bcc5" }}
                    >
                        <video autoPlay loop muted playsInline>
                            <source src="/assets/projects/senmy/senmy-show.mp4" type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </section>

                    <section className="pictok__mainContainer">
                        <div className="pictok__mainTitle">
                            <h2 style={{ color: "#000" }}>Overview</h2>
                        </div>
                        <div className="pictok__mainContent">
                            <p>As a Communications Coordinator at Senmy Canada, I led the website redesign to create a clear, user-friendly first point of contact where customers could explore Senmy’s philosophy, products, and approach to beauty.</p>
                            <Link className="infj__btn" style={{ display: "flex", justifyContent: "center", textDecoration: "none", outline: "none" }} to="https://xiarongrachel.wixstudio.com/senmy" target="_blank" rel="noopener noreferrer">
                                <button style={{ backgroundColor: "#3b234f", color: "#fff", borderColor: "#3b234f", outline: "none" }}>
                                    <p><strong>Visit the website ↗</strong></p>
                                </button>
                            </Link>
                        </div>
                    </section>

                    <section className="pictok__mainContainer">
                        <div className="pictok__mainTitle">
                            <h2 style={{ color: "#000" }}>Old vs. New</h2>
                        </div>
                        <div className="pictok__mainContent">
                               <p>As a Communications Coordinator at Senmy Canada, I led the website redesign to create a clear, user-friendly first point of contact where customers could explore Senmy’s philosophy, products, and approach to beauty.</p>
                               <p>The original dark background was replaced with white to showcase the products more clearly. Larger typography and a simplified layout improve readability while reinforcing the company’s elegant and luxurious brand identity.</p>
                            {redesignComparisons.map((comparison, comparisonIndex) => (
                                <div key={comparison.title} style={{ marginBottom: "3em" }}>
                                    
                                    <h3 style={{ color: "#000" }}>{comparison.title}</h3>
                                    <div style={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                                        gap: "2em",
                                    }}>
                                        <div style={{ position: "relative" }}>
                                            <img
                                                src={`/assets/projects/senmy/${comparison.newImage}`}
                                                alt={`${comparison.title} new design`}
                                                onClick={() => {
                                                    setLightboxIndex(comparisonIndex * 2 + 1);
                                                    setLightboxOpen(true);
                                                }}
                                                style={{ display: "block", width: "100%", height: "16em", objectFit: "contain", borderRadius: "1em", cursor: "zoom-in" }}
                                            />
                                            <p style={{ position: "absolute", left: "0.75em", bottom: "0.75em", margin: 0, padding: "0.25em 0.5em", color: "#000", backgroundColor: "rgba(255, 255, 255, 0.8)", borderRadius: "0.5em", fontWeight: "600" }}>New</p>
                                        </div>
                                        <div style={{ position: "relative" }}>
                                            <img
                                                src={`/assets/projects/senmy/${comparison.oldImage}`}
                                                alt={`${comparison.title} old design`}
                                                onClick={() => {
                                                    setLightboxIndex(comparisonIndex * 2);
                                                    setLightboxOpen(true);
                                                }}
                                                style={{ display: "block", width: "100%", height: "16em", objectFit: "contain", borderRadius: "1em", cursor: "zoom-in" }}
                                            />
                                            <p style={{ position: "absolute", left: "0.75em", bottom: "0.75em", margin: 0, padding: "0.25em 0.5em", color: "#000", backgroundColor: "rgba(255, 255, 255, 0.8)", borderRadius: "0.5em", fontWeight: "600" }}>Old</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                    <Lightbox
                        open={lightboxOpen}
                        index={lightboxIndex}
                        close={() => setLightboxOpen(false)}
                        slides={comparisonSlides}
                        plugins={[Thumbnails]}
                        thumbnails={{
                            position: "start",
                            width: 180,
                            height: 100,
                            borderRadius: 8,
                            gap: 12,
                        }}
                    />

                    <section className="pictok__mainContainer">
                        <div className="pictok__mainTitle">
                            <h2 style={{ color: "#000" }}>Details</h2>
                        </div>
                        <div className="pictok__mainContent">
                            <p>This project was still in progress and the work shown here was designed by me. This part has been authorized for inclustion in portfolio.</p>
                        </div>
                    </section>
                </div>
            </div>

            <ProjectFooter projectName="senmy" />
        </Transition>
    );
}
